const MissionVisionValuesPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-blue-50 via-white to-sky-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              Missão, Visão e Valores
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-sky-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="flex items-start mb-8">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center flex-shrink-0 mr-6">
                  <i className="ri-target-line text-3xl text-white"></i>
                </div>
                <div>
                  <h2 className="text-4xl font-bold text-gray-900 mb-6">
                    Nossa Missão
                  </h2>
                  <p className="text-xl text-gray-700 leading-relaxed">
                    Fornecer alimentos em pó de alta qualidade, desenvolvendo soluções inovadoras e práticas que atendam às necessidades de nossos clientes em diversos segmentos, sempre com compromisso com a excelência, segurança alimentar e satisfação do consumidor final.
                  </p>
                </div>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-sky-50 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Nosso Compromisso
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-check-line text-2xl text-blue-600 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Qualidade superior em todos os nossos produtos</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-2xl text-blue-600 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Ingredientes cuidadosamente selecionados</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-2xl text-blue-600 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Auditorias frequentes e rigorosas</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-2xl text-blue-600 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Atendimento personalizado e eficiente</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8ce16e0246f24fd6b4eca44aad56ef47.png"
                  alt="Missão Sustentare"
                  className="w-full h-full object-contain bg-white p-8"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl bg-white flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/eface71f0e253c04b16895cda0870d8f.png"
                  alt="Visão Sustentare"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div>
              <div className="flex items-start mb-8">
                <div className="w-16 h-16 bg-gradient-to-br from-sky-500 to-sky-600 rounded-2xl flex items-center justify-center flex-shrink-0 mr-6">
                  <i className="ri-eye-line text-3xl text-white"></i>
                </div>
                <div>
                  <h2 className="text-4xl font-bold text-gray-900 mb-6">
                    Nossa Visão
                  </h2>
                  <p className="text-xl text-gray-700 leading-relaxed mb-6">
                    Ser reconhecida como referência nacional e internacional na produção de alimentos em pó, expandindo nossa presença em mercados estratégicos e consolidando parcerias duradouras com clientes que buscam qualidade, inovação e confiabilidade.
                  </p>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Buscamos crescimento sustentável, investindo continuamente em tecnologia, capacitação de equipes e desenvolvimento de novos produtos que agreguem valor aos nossos parceiros comerciais.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center">
                <i className="ri-heart-3-line text-3xl text-white"></i>
              </div>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Nossos Valores
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              A nossa receita é simples: princípios sólidos que guiam todas as nossas ações
            </p>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-sky-500 mx-auto mt-6"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Confiança
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Construímos relacionamentos duradouros baseados em transparência, honestidade e cumprimento de compromissos.
              </p>
            </div>

            <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-20 h-20 bg-gradient-to-br from-sky-500 to-sky-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Inovação
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Buscamos constantemente novas soluções, tecnologias e produtos que agreguem valor aos nossos clientes.
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-20 h-20 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Respeito
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Valorizamos pessoas, parceiros e o meio ambiente, promovendo um ambiente de trabalho ético e colaborativo.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-medal-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Seriedade
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Agimos com profissionalismo, responsabilidade e comprometimento em todas as nossas operações.
              </p>
            </div>
          </div>

          {/* Values in Action */}
          <div className="bg-gradient-to-br from-blue-500 to-sky-500 rounded-3xl p-12 lg:p-16 text-white shadow-2xl">
            <div className="text-center">
              <i className="ri-star-line text-6xl mb-6"></i>
              <h3 className="text-3xl lg:text-4xl font-bold mb-6">
                Valores em Ação
              </h3>
              <p className="text-xl lg:text-2xl leading-relaxed max-w-4xl mx-auto">
                Estes valores não são apenas palavras, mas princípios que vivemos diariamente. Eles orientam nossas decisões, moldam nossa cultura organizacional e definem como nos relacionamos com clientes, fornecedores, colaboradores e a comunidade.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Differentials Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-sky-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              O que nos diferencia
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Mais de 25 anos de experiência transformando ingredientes em soluções
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-award-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Qualidade Certificada
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Auditorias frequentes e rigorosos controles de qualidade garantem a excelência de nossos produtos.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-sky-500 to-sky-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-global-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Alcance Global
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Presença em diversos países da América Latina, África e Ásia, levando qualidade brasileira ao mundo.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-team-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Equipe Especializada
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Profissionais capacitados e comprometidos em oferecer as melhores soluções para cada cliente.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8">
            Faça parte da nossa história
          </h2>
          <p className="text-xl text-gray-600 mb-10">
            Conheça mais sobre a Sustentare e descubra como podemos ser o parceiro ideal para o seu negócio
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contato"
              className="inline-flex items-center justify-center px-10 py-5 bg-gradient-to-r from-sky-500 to-sky-600 text-white text-lg font-semibold rounded-xl hover:from-sky-600 hover:to-sky-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-3 text-2xl"></i>
              Entre em Contato
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MissionVisionValuesPage;